export interface Category {
  name: string;
  slug: string;
  url: string;
}

export const categories: Category[] = [
  { name: 'Обувь', slug: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Худи / Свитера', slug: 'Hoodies', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { name: 'Футболки', slug: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { name: 'Куртки', slug: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { name: 'Брюки / Шорты', slug: 'Pants', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { name: 'Головные уборы', slug: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { name: 'Комплекты', slug: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { name: 'Нижнее белье', slug: 'Underwear', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { name: 'Джерси', slug: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { name: 'Аксессуары', slug: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { name: 'Сумки', slug: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { name: 'Ремни', slug: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { name: 'Парфюмерия', slug: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { name: 'Прочее', slug: 'Other', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];